"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chevronUp = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m12.0001 6.9394 8.0007 8.0013-1.4142 1.4141L12 9.7678l-6.5869 6.586-1.414-1.4143 8.001-8z" } }];
exports.iconName = 'chevron-up';
exports.chevronUp = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
